// Frases de error de la interna (sin JSX, para que comun.tsx solo exporte componentes).

/** Error de una consulta → frase para la pantalla (sin tecnicismos cuando se puede). */
export function mensajeDeError(e: unknown): string {
  const msg = String((e as { message?: string } | null)?.message ?? e ?? "").trim();
  if (/failed to fetch|networkerror|load failed|network request failed/i.test(msg))
    return "No hay conexión con la base. Revisa el internet y vuelve a intentar.";
  if (/JWT|not authenticated|sesi[oó]n/i.test(msg)) return "Tu sesión terminó. Sal y vuelve a entrar.";
  if (/row-level security|permission denied|JSON object requested|0 rows|PGRST116|406/i.test(msg))
    return "La base no dejó leer estos datos con esta cuenta. ¿Entraste con tu usuario de la agencia?";
  if (/No item with identifier|not found/i.test(msg)) return "Ese registro no existe (o esta cuenta no tiene acceso a él).";
  return msg || "Error desconocido.";
}
